import { create } from "zustand";
import { getStoredAccessToken, setStoredAccessToken, setStoredApiBaseUrl } from "../api/client";
import { isTokenExpired } from "../utils/jwt";
import type { AuthUser } from "../types/auth";

export type { AuthUser };

type AuthState = {
  accessToken: string | null;
  user: AuthUser | null;
  hydrate: () => void;
  setAccessToken: (token: string | null) => void;
  setUser: (user: AuthUser | null) => void;
  clearSession: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,

  hydrate: () => {
    const t = getStoredAccessToken();
    if (!t || isTokenExpired(t)) {
      setStoredAccessToken(null);
      setStoredApiBaseUrl(null);
      set({ accessToken: null, user: null });
      return;
    }
    set({ accessToken: t });
  },

  setAccessToken: (token) => {
    if (token) {
      setStoredAccessToken(token);
      set({ accessToken: token });
    } else {
      setStoredAccessToken(null);
      set({ accessToken: null, user: null });
    }
  },

  setUser: (user) => set({ user }),

  clearSession: () => {
    setStoredAccessToken(null);
    setStoredApiBaseUrl(null);
    set({ accessToken: null, user: null });
  },
}));
